import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MainRoutingModule } from "./main-routing.module";
import { EpAppStore } from "../shared/services/epAppStoreService/epAppStore.service";
import { PermissionsService } from "../shared/services/permissions/permissions.service";

import { MainComponent } from "./main.component";
import { HeaderComponent } from "./header/header.component";
import { FooterComponent } from "./footer/footer.component";
// import { OrchidLinkModule } from '@upmc-healthplan-npm/orchid-link/src/ng';

@NgModule({
  declarations: [MainComponent, HeaderComponent, FooterComponent],
  imports: [
    CommonModule,
    MainRoutingModule,
    // OrchidLinkModule
  ],
  providers: [
    EpAppStore, // keeps state alive
    PermissionsService,
  ],
})
export class MainModule {}
